import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, AutocompleteProps } from '@mui/material';
import clsx from 'clsx';
import { Input } from 'components/Form/Input/Input';
import React from 'react';
import { Option } from 'types/Generics';

import classes from './SelectAutocomplete.module.scss';

interface SelectAutocompleteProps<T>
    extends Omit<
        AutocompleteProps<Option<T>, false, false, false, 'div'>,
        'options' | 'renderInput' | 'onChange'
    > {
    label?: string;
    error?: boolean;
    required?: boolean;
    options: Array<Option<T>>;
    onChange?: (value: Option<T> | null) => void;
}

export const SelectAutocomplete = <T,>(props: SelectAutocompleteProps<T>) => {
    const onChange = (e: React.ChangeEvent<EventTarget>, value: Option<T> | null) => {
        props.onChange?.(value);
    };

    return (
        <div className={classes.root}>
            <FontAwesomeIcon icon={faSearch} className={classes.searchIcon} />
            <Autocomplete
                renderInput={params => (
                    <Input
                        {...params}
                        error={props.error}
                        label={props.label}
                        required={props.required}
                    />
                )}
                ListboxProps={{ className: classes.listbox }}
                getOptionLabel={(option: Option<T>) => option.name ?? ''}
                renderOption={(props, option) => (
                    <li {...props} key={String(option.id)}>
                        {option.name}
                    </li>
                )}
                {...props}
                className={clsx(classes.autocomplete, props.className)}
                onChange={onChange}
            />{' '}
        </div>
    );
};
